module.exports = __webpack_public_path__ + "static/img/14bg_4.03a045b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_4.png
// module id = 646
// module chunks = 1